import { TextField } from "@mui/material";
import { clsx } from "clsx";
import Preloader from "components/UI/Preloader";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { ToggleButton } from "components/buttons/ToggleButton";
import UploadMoveBack from "components/upload/UploadMoveBack";
import VerifiedUserIcon from "components/UI/VerifiedUserIcon";
import "./styles/UploadFifthStep.scss";
import { useCallback } from "react";
import { metrics } from "../../../utils/metrics";

interface IUploadFifthStepProps {
  back: () => void;
  description: string | null;
  setDescription: (text: string) => void;
  isPrivate: boolean;
  handlePrivate: () => void;
  isFetching: boolean;
  uploadError: string | null;
  progressPercent: number;
  fileType: string | null;
  isUserVerified: boolean | undefined;
  updateGifSettings: () => void;
}

const UploadFifthStep = (props: IUploadFifthStepProps) => {
  const {
    back,
    description,
    setDescription,
    isPrivate,
    handlePrivate,
    isFetching,
    uploadError,
    progressPercent,
    fileType,
    isUserVerified,
    updateGifSettings
  } = props;
  const navigate = useNavigate();

  const handleGetVerified = useCallback(async () => {
    await metrics.sendUploadGetVerifiedClicked();
    navigate(routes.verify());
  }, [navigate]);

  const handlePublish = useCallback(async () => {
    await metrics.sendUploadPublished();
    updateGifSettings();
  }, [updateGifSettings]);

  return (
    <div className="UploadFifthStep">
      <div className={
        clsx(
          "UploadFifthStep-Description",
          isUserVerified && "UploadFifthStep-Description_isVerified"
        )
      }>
        <UploadMoveBack back={back} text={"Description"}/>
        <p className="UploadFifthStep-DescriptionTitle">
          {isUserVerified ? "Write some words to describe your video:" : "Descriptions are only available for verified users."}
        </p>
        <p className="UploadFifthStep-DescriptionSubTitle">
          Click below to apply for your account to be verified
        </p>
        <TextField
          multiline={true}
          rows={4}
          value={description}
          placeholder="Describe your GIF in a few words"
          onChange={(e) => setDescription(e.target.value)}
          disabled={!isUserVerified}
          sx={{
            marginTop: "16px",
            width: "100%",
            background: "transparent",
            "& label.Mui-focused": {
              color: "#D8DFEC"
            },
            "*": {
              fontFamily: "'Poppins', sans-serif!important",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "1px solid rgba(216, 223, 236, 0.3)"
            },
            "& textarea.Mui-disabled": {
              "-webkit-text-fill-color": "rgba(255, 255, 255, 0.3)",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              fontSize: "14px",
              color: "white",
              border: "1px solid rgba(216, 223, 236, 0.3)",
              "&.Mui-disabled": {
                border: "1px solid rgba(216, 223, 236, 0.3)"
              }
            },
            "& .MuiFormHelperText-root.Mui-error": {
              margin: 0,
              marginTop: 5,
            }
          }}
        />
        {/* TODO: Remove BaseButton styles (when component from the another branch will be on staging) */}
        <button className="BaseButton BaseButton_isSecondary" onClick={handleGetVerified}>
          <VerifiedUserIcon />
          Get Verified
        </button>
      </div>
      <div className="UploadFifthStep-Options">
        <h3>Options</h3>
        <div className="UploadFifthStep-OptionsWrap">
          <div className="UploadFifthStep-Option">
            <p>Make Private</p>
            <ToggleButton checked={isPrivate} onChange={handlePrivate}/>
          </div>
        </div>
      </div>
      <div className="UploadFifthStep-UploadBtn">
        {/* TODO: Remove BaseButton styles (when component from the another branch will be on staging) */}
        <button
          className="BaseButton BaseButton_isPrimary"
          onClick={handlePublish}
          disabled={isFetching || uploadError !== null}
        >
          {isFetching ? (
            <Preloader progressPercent={fileType === "multiple" ? null : progressPercent}/>
          ) : <span>Publish</span>}
        </button>
      </div>
    </div>
  );
};

export default UploadFifthStep;
